import React from 'react';

import { FormField, Label } from '@zillow/constellation';

import YesAndNo from '../../../Widgets/YesAndNo';

type Props = {
  yesHandler: () => void;
  noHandler: () => void;
  yesActive: boolean;
  dataTest?: string;
};

export default function PetsInsuranceYesAndNo({ ...props }: Props) {
  return (
    <FormField
      label={<Label>Will your lease require renters insurance coverage for pets?</Label>}
      control={<YesAndNo {...props} />}
    />
  );
}
